export const API = {
  boards: "/boards",
  tasks: "/tasks",
  tasksAttachments: "/tasks/attachments",
  tasksComments: "/tasks/comments",
  tasksSubtasks: "/tasks/subtasks",
  tasksAssignees: "/tasks/assignees",
  tasksCounts: "/tasks/counts",
  tasksArchive: "/tasks/archive",
  tasksExport: "/tasks/export",
  tasksPropertiesLookup: "/tasks/properties-lookup",
  taskLists: "/task-lists",
  taskListsReorder: "/task-lists/reorder",
  taskTags: "/task-tags",
  taskTemplates: "/task-templates",
  signup: "/owners",
  adminSignIn: "/oauth/token",
  propertiesSearch: "/properties-search",
  properties: "/properties",
  settings: "/settings",
  settingsReset: "/settings/reset",
  settingsPreview: "/settings/preview",
  settingsLogs: "/settings/logs",
  settingsPropertyColumns: "/settings/property-columns",
  settingsPrintFileNames: "/settings/print-file-names",
  settingsMapStyle: "/settings/map-style",
  settingsPacketSectionCreate: "/settings/packet-sections/create",
  settingsPacketSectionUpload: "/settings/packet-sections/upload",
  settingsPacketSectionDelete: "/settings/packet-sections/delete",
  ownerPortalProperties: "/owner-portal/properties",
  ownerPortalAppeals: "/owner-portal/appeals",
  ownerPortalInvoices: "/owner-portal/invoices",
  getOwnersList: "/properties?documents_yn=1",
  getInvoicesList: "/owners/invoices",
  getOwnersSimpleList: "/owners/simple-list",
  sendReferralEmail: "/send-referral-email",
  ownersEmailList: "/owners/autocomplete/email",
  referrals: "/referrals",
  syncProperty: "/sync-property",
  getDocProperties: "/get-doc-properties",
  update: "/update",
  addDocProperty: "/add-property",
  checkPropertyMailing: "/check-property-mailing",
  accountLogs: "/account-logs",
  propertyOwner: "/property-owner",
  checkEmail: "/check-user",
  checkCode: "/verify-code",
  getColumnOrder: "/get-sequence",
  saveColumnOrder: "/save-sequence",
  getProtestedAccountsList: "/protested-accounts",
  uploadFile: "/upload-file",
  getHearingDatesList: "/hearing-dates",
  notes: "/notes/update-or-create",
  me: "/owner-portal/me",
  ownerPortal: "/owner-portal",
  leads: "/leads",
  documents: "/documents",
  documentsAoa: "/documents/aoa",
  documentsSa: "/documents/sa",
  docs: "/docs",
  fullInfo: "/full-info",
  refreshProperty: "/refresh",
  updateTxt: "/update-texts",
  sendAoA: "/send-aoa",
  ownerReferrals: "/owner-referrals",
  exportCSV: "/export-csv",
  agentExportCSV: "/agent-export-csv",
  syncProperties: "/sync-properties",
  ownerReferredBy: "/owner-referred-by",
  propertiesSearchAddress: "/properties-search-address",
  getPropertyInfo: "/get-property-info",
  multipleCreate: "/multiple-create",
  archives: "/archives",
  contactAgain: "/contact-again",
  contactUs: "/contact-us",
  evidences: "/evidences",
  evidencesSearch: "/search",
  evidenceStatus: "/get-comps-status",
  changeCompsStatus: "/change-comps-status",
  comps: "/comps",
  importAccounts: "/import-accounts",
  importNotes: "/import-notes",
  importArchiveProperties: "/import-archive-properties",
  getSaveComps: "/get-save-comps",
  selectedComps: "/selected-comps",
  leftBarValues: "/left-bar/values",
  saveComps: "/save-comps",
  equities: "/equities",
  sales: "/sales",
  salesRatio: "/sales-ratio",
  massPrint: "/mass-print",
  massPrintJobs: "/mass-print-jobs",
  massPrintActive: "/active",
  massPrintDownload: "/download",
  massPrintAttachment: "/attachment",
  massPrintGenerate: "/generate",
  massPrintReanalyze: "/reanalyze",
  massPrintArchive: "/archive",
  massPrintReport: "/report",
  categories: "/categories",
  propertyDocuments: "/property-documents",
  propertyIndex: "/property-index",
  propertyIndexCounties: "/counties",
  massUpload: "/mass-upload",
  massUploadValidate: "/validate",
  massUploadFiles: "/files",
  massUploadCommit: "/commit",
  massUploadActive: "/active",
  massUploadReport: "/report",
  propertyDocumentsUploadLimits: "/upload-limits",
  propertyDocumentsProperty: "/property",
  propertyProfile: "/properties/property-profile",
  propertyDocumentsDownload: "/download",
  propertyDocumentsLookup: "/properties-lookup",
  propertyDocumentsCounts: "/counts",
  print: "/print",
  printFullComp: "/print-full-comp",
  printComp: "/print-comp",
  screenshots: "/screenshots",
  opinionValue: "/opinion-value",
  noticeValue: "/notice-value",
  dcadSalesAdj: "/dcad-sales-adj",
  archiveProperty: "/properties/archive",
  clientEvidence: "/client-evidences",
  changeEvidenceStatus: "/change-evidence-status",
  changeFileStatus: "/change-file-status",
  mergeEvidenceFiles: "/evidence-file-merge",
  changeFileType: "/change-file-type",
  changeFileName: "/change-file-name",
  adminUsers: "/admin/users",
  usersMe: "/users/me",
  usersMeAvatar: "/users/me/avatar",
  usersMeActivity: "/users/me/activity",
  usersMeActivityDay: "/users/me/activity/day",
  usersChangePassword: "/users/change-password",
  addFile: "/add-file",
  getAllPermissions: "/get-all-permissions",
  archivedAgents: "/archived",
  archiveAgent: "/archive",
  unarchiveAgent: "/unarchive",
  admin: "/admin",
  aoaDocs: "/aoa-docs",
  saDocs: "/sa-docs",
  verifyAllAoa: "/sync-yes-properties",
  action: "/action",
  actions: "/actions",
  tracker: "/tracker",
  owners: "/owners",
  flags: "/flags",
  property: "/property",
  deleteProperty: "/delete-property",
  addReceiver: "/add-receiver",
  discounts: "/discounts",
  ownersWithDiscounts: "/owners-with-discounts",
  updateSender: "/update-sender",
  completeSignup: "/complete-signup",
  dashboard: "/v2properties",
  updateComment: "/update-comment",
  unarchiveProperty: "/unarchive",
  getAppliedFilters: "/get-filters",
  filters: "/filters",
  save: "/save",
  subject: "/subject",
  addCompByAccountNumber: "/add-comp-by-account-number",
  searchComps: "/search",
  toggleFlagComp: "/toggle-flag",
  updateEvidence: "/evidence",
  cadSelection: "/cad-selection",
  cadMedian: "/cad-median",
  accountNumber: "/account-number",
  streetAddress: "/street-address",
  propertyOwnerName: "/owner",
  propertyLocation: "/location",
  propertyMailingAddress: "/mailing-address",
  file: "/file",
  upcomingHearings: "/upcoming-hearings",
  complete: "/complete",
  getNotes: "/property-notes",
  evidenceNotes: "/evidence-notes",
  createEvidenceNote: "/evidence-notes",
  deleteEvidenceNote: "/evidence-notes",
  internalNotes: "/internal-notes",
  createInternalNote: "/internal-notes",
  notifications: "/notifications",
  read: "/read",
  updateEmail: "/update-email",
  referralsOwnerPortal: "/owner-portal/owner-referrals",
  referredByOwnerPortal: "/owner-portal/owner-referred-by",
  getOwnerReferralCode: "/owner-portal/owner-referral-code",
  authedOrNot: "/owner-portal/authed-or-not",
  updateAccountInfo: "/owner-portal/owner",
  getNotifications: "/admin/notification",
  readAllNotifications: "/admin/notification/read",
  archiveFile: "/archive-file",
  changeContactedStatus: "/change-contacted-status",
  updatePhoneNumber: "/update-phone-number",
  updateTableConfigs: "/fe-table-configs/update",
  mailingColumns: "/mailing-columns",
  addUsersToColumn: "/mailing-columns/add-users",
  removeUsersToColumn: "/mailing-columns/remove-users",
  updateColumnIndexes: "/mailing-columns/update-indexes",
  importUsers: "/mailing-columns/import-users",
  dispatchEmails: "/mailing-columns/dispatch-emails",
  saveFilterPreferences: "/user-filter-preferences/save",
  getFilterPreferences: "/user-filter-preferences/get",
  selectVersion: "/select",
  signature: "/signature",
  analyticsSummary: "/admin/analytics/summary",
  analyticsCharts: "/admin/analytics/charts",
  analyticsAgentsEvidence: "/admin/analytics/agents-evidence",
  analyticsYearOverYear: "/admin/analytics/year-over-year",
  analyticsYearOverYearCounty: "/admin/analytics/year-over-year-county",
  analyticsSignupTimeComparison: "/admin/analytics/signup-time-comparison",
  analyticsSignupTimeComparisonCounty: "/admin/analytics/signup-time-comparison-county",
  signupTrackingDaily: "/admin/analytics/sign-ups/daily",
  signupTrackingHourly: "/admin/analytics/sign-ups/hourly",
  signupTrackingWeekOverWeek: "/admin/analytics/sign-ups/week-over-week",
  signupTrackingYearOverYear: "/admin/analytics/sign-ups/year-over-year",
  signupTrackingProjections: "/admin/analytics/sign-ups/projections",
  maverickFields: "/admin/maverick/fields",
  maverickFormulaColumns: "/admin/maverick/fields/formula-columns",
  maverickFormulaValidate: "/admin/maverick/adjustment-formula/validate",
  maverickSettings: "/admin/maverick/settings",
  maverickAccess: "/admin/maverick/access",
  maverickOptionsTemplate: "/admin/maverick/options/template",
  maverick2PageConfig: "/comps/maverick2/page-config",
  maverick2GetFilters: "/comps/maverick2/get-filters",
  maverick2Equities: "/comps/maverick2/equities",
  maverick2Sales: "/comps/maverick2/sales",
  maverick2PrintFullComp: "/comps/maverick2/print-full-comp",
  maverick2LeftBarValues: "/comps/maverick2/left-bar/values",
  maverick2State: "/comps/maverick2/state",
  maverickActionTrace: "/comps/action-trace",
  maverick2ActionTrace: "/comps/maverick2/action-trace",
  maverickProfiles: "/comps/maverick-profiles",
  maverick2Profiles: "/comps/maverick2/maverick-profiles",
};
